import { Model } from 'app/model/backendmodel';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Metamodel } from 'app/model/base/model';

import { Activity } from 'app/model/pipeline/activity';
import { Owned } from 'app/model/base/named';
import { ValueAdapter } from 'app/model/adapters/value.adapter';
import { writeBehaviorOptionValues } from 'app/shared/constants/write-behavior.const';
import { CopySinkAdapter } from './copysink.adapter';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { MongoDbAtlasCopySink } from 'app/model/pipeline/copysink/mongo-db-atlas.copysink';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(MongoDbAtlasCopySink),
    asynchronous: true,
    adapts: {
        type: '*',
        writeBehavior: '*',
        writeBatchSize: '*',
        writeBatchTimeout: '*'
    }
})
export class MongoDbAtlasCopySinkAdapter extends CopySinkAdapter<MongoDbAtlasCopySink, Model.MongoDbAtlasSink> {
    protected override async _toResource(model: MongoDbAtlasCopySink): Promise<Model.MongoDbAtlasSink> {
        const result: Model.MongoDbAtlasSink = {
            type: adfModelTypeMap.mongoDbAtlas.copySinkType
        };
        const writeBatchTimeout = ValueAdapter.toResource(model, MongoDbAtlasCopySink.WRITE_BATCH_TIMEOUT);
        if (writeBatchTimeout != null && writeBatchTimeout !== '') {
            // don't need pass '' to backend
            result.writeBatchTimeout = writeBatchTimeout;
        }
        result.writeBatchSize = ValueAdapter.toResource(model, MongoDbAtlasCopySink.WRITE_BATCH_SIZE);
        result.writeBehavior = ValueAdapter.toResource(model, MongoDbAtlasCopySink.WRITE_BEHAVIOR);
        CopySinkAdapter.toCommonCopySinkResource(model, result, this.context);
        return result;
    }

    protected override async _toModel(
        resource: Model.MongoDbAtlasSink,
        owner: Activity
    ): Promise<MongoDbAtlasCopySink> {
        const result = Owned.create<MongoDbAtlasCopySink>(Metamodel.modelFor(MongoDbAtlasCopySink), owner);
        ValueAdapter.toModel(result, MongoDbAtlasCopySink.WRITE_BATCH_TIMEOUT, resource.writeBatchTimeout);
        ValueAdapter.toModel(result, MongoDbAtlasCopySink.WRITE_BATCH_SIZE, resource.writeBatchSize);

        // handle upper case and lower case
        let writeBehavior = resource.writeBehavior;
        if (writeBehavior && typeof writeBehavior === 'string') {
            const lowerCaseValue = writeBehavior.toLowerCase();
            switch (lowerCaseValue) {
                case writeBehaviorOptionValues.insert:
                    writeBehavior = writeBehaviorOptionValues.insert;
                    break;
                case writeBehaviorOptionValues.upsert:
                    writeBehavior = writeBehaviorOptionValues.upsert;
                    break;
                default:
                    break;
            }
        }
        ValueAdapter.toModel(result, MongoDbAtlasCopySink.WRITE_BEHAVIOR, writeBehavior);
        CopySinkAdapter.toCommonCopySinkModel(result, resource);
        return result;
    }
}
